<template>
    <front-layout title="Quem Somos">
        
            <div class="container px-4 pt-40 pb-20 mx-auto">
                <div class="flex flex-col lg:flex-row lg:space-x-10 items-center min-h-[100vh]">
                    <div class="flex-1">
                        <img src="/images/about_img_1.png" alt="imagem" class="w-full">
                    </div>

                    <div class="flex-1 text-lg">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" v-html="about_rigor" id="about_rigor" class="bg-white inline-block p-2 rounded-lg">
                        </div>

                        <div v-else v-html="about_rigor"></div>

                        <a :href="route('contactos')" class="mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Fale connosco <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a>
                   
                    </div>
                </div>

                 <div class="flex flex-col lg:flex-row lg:space-x-10 mt-8 lg:mt-0 items-center min-h-[100vh]">
                    <div class="flex-1 text-lg">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" v-html="about_visao" id="about_visao" class="bg-white inline-block p-2 rounded-lg">
                        </div>

                        <div v-else v-html="about_visao"></div>


                        <a :href="route('contactos')" class="mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Fale connosco <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a>
                     
                    </div>
                    <div class="flex-1">
                        <img src="/images/about_img_2.png" alt="imagem" class="w-full">
                    </div>
                </div>

                <div class="flex flex-col lg:flex-row lg:space-x-10 items-center min-h-[100vh]">
                    <div class="flex-1">
                        <img src="/images/about_img_3.png" alt="imagem" class="w-full">
                    </div>

                    <div class="flex-1 text-lg">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" v-html="about_qualidade" id="about_qualidade" class="bg-white inline-block p-2 rounded-lg">
                        </div>

                        <div v-else v-html="about_qualidade"></div>

                        <a :href="route('contactos')" class="mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Fale connosco <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></a>
                   
                    </div>
                </div>
            </div>
     
    </front-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            about_rigor: String,
            about_visao: String,
            about_qualidade: String
        },
        data() {
            return {
                enableEdit: false,
                form: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        methods: {
            updateText(e) {
                this.form.setting = e.target.id
                this.form.content = e.target.innerHTML,
                this.form.route = this.route().current()
            },
            updateSettings(e) {
                if(this.form.setting != '' && this.form.content != '' & this.form.route != '') {
                    this.form.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
        },
    })
</script>
